import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterEvent } from '@angular/router';
import { Subscription } from 'rxjs';
import { NdmsSafeSubscriber } from 'projects/shared/core/interfaces/ndms-safe-subscriber';
import { NdmsAuthService } from 'ndms/app/shared/core-ndms/services/ndms-auth.service';
import { HirAuthApiService } from 'projects/hir/app/shared/core-hir/hir-auth.service';
import { RoleConstants } from 'projects/hir/app/shared/core-hir/role.constants';
import { HirAccessService } from 'projects/hir/app/shared/core-hir/hir-access.service';
import { RmsUserGuideService } from 'projects/rms/app/shared/core-rms/rms-user-guide.service';
import { RmsUserGuideConstants } from 'projects/rms/app/shared/core-rms/rms-user-guide.constants';

@Component({
  selector: 'hir-nav',
  templateUrl: './hir-nav.component.html',
  styleUrls: ['./hir-nav.component.scss']
})
export class HirNavComponent extends NdmsSafeSubscriber implements OnInit {
  @Output() initializePrograms = new EventEmitter<any>();

  authSubscription: Subscription;
  authorized: boolean = false;
  authInProg: boolean = true;
  trainingMode: boolean = false;
  routerLink: string = '/';
  iconBase: string = '';
  navigating: boolean = false;

  tabs: any[] = [];
  tabsShow: {} = {
    'admin': false,
    'deployments': false,
    'patients': false,
    'responders': false,
    'veterinaryMedicine': false,
    'users': false
  };

  title: 'HIR';
  toastOptions = {
    position: ["top", "right"],
    timeOut: 5000,
    lastOnBottom: true
  };

  currentLocationText: string;
  locationChangedSub: Subscription;
  userPermissions: any[] = [];

  constructor(
    @Inject('APP_PATH') public appPath: string,
    @Inject('SITE_MODE') public siteMode: string,
    @Inject('PROGRAM') public program: string,
    @Inject('BASE_URL') baseUrl: string,
    private router: Router,
    private ndmsAuthApiService: NdmsAuthService,
    private authApiService: HirAuthApiService,
    public accessService: HirAccessService,
    public roleConstants: RoleConstants,
    private rmsUserGuideService: RmsUserGuideService) {
    super();

    this.iconBase = baseUrl;
    this.routerLink = this.routerLink + appPath;
    this.trainingMode = siteMode === 'train';
    
    router.events.subscribe((e: RouterEvent) => {
      if (e instanceof NavigationStart) {
        this.navigating = true;
      } else if (e instanceof NavigationEnd || e instanceof NavigationError || e instanceof NavigationCancel) {
        this.navigating = false;
      }
    });
  }

  ngOnInit(): void {
    this.userPermissions = this.accessService.currentUser.userPermissions;
    this.initializePrograms.emit(this.tabsShow);
  }

  siteHeaderText = (this.siteMode === 'train'?'Training':this.siteMode);

  isProdSite(){
    return this.siteMode === 'prod'; //environment.production  environment.systemMode
  }

  downloadUserGuide() {
    this.rmsUserGuideService.downloadUserGuide(RmsUserGuideConstants.HIRCategory);
  }

  trainingWrapper() {
    return this.trainingMode ? "training-wrapper" : "";
  }

  //Navigate in a way that forces the page to reload, even if we're already on it
  freshNav(event, url: string) {
    event.preventDefault(); //override the href (we can't remove href/routerlink from the template for accessibility reasons)

    const tree = this.router.parseUrl(url);
    if (this.router.isActive(tree, false)) {  //link is to current URL, so redirect through home to force a reload
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([url], { queryParams: { clear: 'true' } });
      });
    } else {  //link is to page other than current, so load it normally
      this.router.navigate([url], { queryParams: { clear: 'true' } });
    }
  }

  logout() {
    this.authApiService.clearToken();
    this.ndmsAuthApiService.logout(true);
    return false;
  }

  login() {
    this.ndmsAuthApiService.login();
    return false;
  }

  onNdmsLinkClicked() {
    this.ndmsAuthApiService.setRedirectUrl('/');
  }

  hasPermission(permission) {
    return this.userPermissions.find(i => i === permission);
  }

}
